import { Invoice } from 'common/modules/billing';

export interface InvoiceWithStoreDetails extends Invoice {
	storeName: string;
}

export type ExtraColumn = 'merchantName';

export interface InvoiceTableStrings {
	statusPending: string;
	statusFailed: string;
	statusCancelled: string;
	statusPaid: string;
	statusRefunded: string;
	retry: string;
	errorStateTitle: string;
	errorStateDescription: string;
	emptyStateTitle: string;
	emptyStateDescription: string;
	headerBillingCycle: string;
	headerDateIssued: string;
	headerStore: string;
	headerInvoiceNo: string;
	headerStatus: string;
	headerAmount: string;
	download: string;
	downloadFailed: string;
}

export const DEFAULT_STRINGS: InvoiceTableStrings = {
	statusPending: 'Pending',
	statusFailed: 'Failed',
	statusCancelled: 'Cancelled',
	statusPaid: 'Paid',
	statusRefunded: 'Refunded',
	retry: 'Retry',
	errorStateTitle: 'Error loading invoices',
	errorStateDescription: 'Please refresh the page to try again',
	emptyStateTitle: 'No data',
	emptyStateDescription: 'No invoices to show',
	headerBillingCycle: 'Cycle',
	headerDateIssued: 'Date issued',
	headerStore: 'Store',
	headerInvoiceNo: 'Invoice #',
	headerStatus: 'Status',
	headerAmount: 'Amount',
	download: 'Download',
	downloadFailed: 'Download failed. Click to retry.',
};
